<div class="to-be-rectified-error-modal-container">
  <div class="to-be-rectified-error-modal-container__error">Wip Validation Error</div>
  <div class="to-be-rectified-error-modal-container__content">
    <div *ngIf="failedEventsVM.length; else defaultTxt">
      <div class="to-be-rectified-error-modal-container__content-error-title">
        Failed to update quantity for below items, please sync to get latest wip numbers
      </div>
      <ion-row class="to-be-rectified-error-modal-container__content-container">
        <li *ngFor="let item of failedEventsVM" class="to-be-rectified-error-modal-container__content-error">
          {{ item.bctxStringWithoutSize }}
          <ion-row class="to-be-rectified-error-modal-container__size-error">
            <ion-col *ngFor="let sizeInfo of item.sizeFailures" [size]="3">
              {{ sizeInfo.size }}: {{ sizeInfo.quantity }}
            </ion-col>
          </ion-row>
        </li>
      </ion-row>
    </div>
    <ng-template #defaultTxt>Something went wrong.Please try after some time</ng-template>
  </div>
  <div class="to-be-rectified-error-modal-container__btn-container">
    <ui-custom-button [btnTxt]="'Okay'" (clickEvent)="dismissModal()"></ui-custom-button>
  </div>
</div>
